<template>
  <div class="time-end">
    <div class="title">
      提示
    </div>
    <template v-if="rank">
      <div class="body" v-if="rank.submitted">
        <img src="/oss/images/enroll/check-icon.png"/>
        <div class="span">
          您的答卷已经提交，请您耐心等待平台评审，评审结束后，平台会与您取得联系并将考试结果呈现给您。
        </div>
      </div>
      <div class="body" v-else>
        <img src="/oss/images/enroll/warn-icon.png"/>
        <div class="span">
          很遗憾！
          <br/>
          本次考试时间已到，你未能成功提交答卷。
        </div>
      </div>
      <div class="button">
        <my_button value="点击返回" @click.native="back"></my_button>
      </div>
    </template>
  </div>
</template>

<script>
import Payment from '@/components/contest/Payment.vue'
import MyButton from '@/components/Button.vue'
export default {
  name: 'Payment',
  components: {
    payment: Payment,
    my_button: MyButton
  },
  data () {
    return {
      rank: null
    }
  },
  methods: {
    back () {
      this.$router.push('/')
    }
  },
  mounted () {
    this.$http.get('/api/rank/me').then(res => {
      this.rank = res.data
    })
  }
}

</script>

<style scoped>
.time-end {
  margin-top: 5.2vw;
  margin-bottom: 5.2vw;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items:center;
}
.title {
  font-size: 24px;
  font-weight: bold;
}
.body {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.span {
  font-size: 18px;
  margin-top: 40px;
  margin-bottom: 60px;
}
.button {
  margin-top: 60px;
  width: 200px;
}

</style>